module.exports = __webpack_public_path__ + "img/bg-home-persona-1.1f62024.png";